import { Component } from '@angular/core';
import { LandingPageComponent } from '../pages/landing-page/landing-page.component';
import { SideBarComponent } from '../components/side-bar/side-bar.component';
import { SpinnerComponent } from '../components/spinner/spinner.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HomeComponent } from '../pages/home/home.component';
import { FooterComponent } from '../components/footer/footer.component';
import { Router } from '@angular/router';
import { Inject } from '@angular/core';
@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [SideBarComponent, CommonModule, RouterModule],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent {
  result: string | null = null;
  constructor(@Inject(Router) public router: Router) { }
  onSpinEnd(prize: string) {
    this.result = prize;
  }

  isSpinnerModule() {
    const current = this.router.url;
    return current === '/dashboard/spinner' || current === '/dashboard/home';
  }

  isTreasurePickRoute(): boolean {
    const current = this.router.url;
    return current === '/dashboard/treasure-pick' || current === '/dashboard/stack-builder' || current === '/dashboard/ace-win' || current === '/dashboard/card-brag-3' || current === '/dashboard/sum-dice' ||  current === '/dashboard/cashbull' || current === '/dashboard/slot-777' ||current === '/dashboard/joker-777' || current === '/dashboard/space-hunt' || current === '/dashboard/aviator' || current === '/dashboard/baccarat'  || current === '/dashboard/keno' || current === '/dashboard/roulette' || current === '/dashboard/chickenroad' || current === '/dashboard/mines' || current === '/dashboard/plinko' || current === '/dashboard/StackBuilder'|| current === '/dashboard/double'|| current === '/dashboard/toss' || current === '/dashboard/slots' || current === '/dashboard/lucky-trigger';
  }

}
